export default function Home() {
  return (
    <div className="flex items-center justify-center h-full bg-gray-100">
      <h1 className="text-4xl md:text-6xl font-bold text-gray-800">
        Dashboard
      </h1>
    </div>
  );
}
